import { isMemberOf } from '~/utils/isMemberOf'
import { ASSEMBLY_PROFILES } from './assembly'

export const HARDWARE_TABS = ['profiles', 'assembly', 'skus', 'makers'] as const

export type HardwareTab = (typeof HARDWARE_TABS)[number]

export const hardwareTabLabel: Record<HardwareTab, string> = {
  profiles: 'Installation profiles',
  assembly: 'Assembly profiles',
  skus: 'SKUs',
  makers: 'Meter makers'
}

export const isHardwareTab = isMemberOf(HARDWARE_TABS)

// The default tab stays out of the URL.
export const toSection = (value: unknown): Exclude<HardwareTab, 'profiles'> | undefined =>
  isHardwareTab(value) && value !== 'profiles' ? value : undefined

export const MISSING_ASSEMBLY_PROFILE_DETAIL =
  'Efento orders are blocked until this profile is mapped to an assembly profile in code.'

export const isAssemblyProfile = isMemberOf(ASSEMBLY_PROFILES)
